
import { toast } from "@/components/ui/sonner";

// Handle year completion and state updates
export const handleYearCompletion = (
  yearsPassed: number,
  advanceYear: () => void,
  setDecisionsThrottled: React.Dispatch<React.SetStateAction<boolean>>,
  setDecisionTimerFired: React.Dispatch<React.SetStateAction<Record<string, boolean>>>,
  setIsSimulating: () => void,
  yearDuration: number,
  setTimeLeft: (timeLeft: number) => void
) => {
  advanceYear();
  
  // Reset decision throttling when a year completes
  setDecisionsThrottled(false);
  setDecisionTimerFired({});
  
  toast(`Year ${yearsPassed + 1} completed!`, {
    description: "Your mining career continues to advance.",
    duration: 3000,
  });
  
  setIsSimulating();
  setTimeLeft(yearDuration);
};

// Failsafe to prevent simulation from getting stuck
export const createSimulationFailsafe = (
  isSimulating: boolean,
  timerRef: React.MutableRefObject<NodeJS.Timeout | null>,
  advanceYear: () => void,
  toast: any,
  yearsPassed: number,
  setIsSimulating: () => void,
  setYearProgress: () => void,
  setDecisionsThrottled: React.Dispatch<React.SetStateAction<boolean>>,
  setTimeLeft: (timeLeft: number) => void,
  yearDuration: number
) => {
  return setTimeout(() => {
    if (isSimulating) {
      if (timerRef.current) {
        clearInterval(timerRef.current);
      }
      advanceYear();
      toast(`Year ${yearsPassed + 1} completed (auto-completed)!`, {
        description: "Your mining career continues to advance.",
        duration: 3000,
      });
      setIsSimulating();
      setYearProgress();
      setDecisionsThrottled(false);
      setTimeLeft(yearDuration);
    }
  }, yearDuration * 2 * 1000);
};
